export default __webpack_public_path__ + "static/media/total.fb04d360.jpg";